import { render, staticRenderFns } from "./edge.vue?vue&type=template&id=68ebad0e&scoped=true&lang=pug&"
var script = {}
import style0 from "./edge.vue?vue&type=style&index=0&id=68ebad0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ebad0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('68ebad0e', component.options)
    } else {
      api.reload('68ebad0e', component.options)
    }
    module.hot.accept("./edge.vue?vue&type=template&id=68ebad0e&scoped=true&lang=pug&", function () {
      api.rerender('68ebad0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/floating_editor/resizer/component/edge.vue"
export default component.exports